import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {UOMUtil} from '../../utils/uomUtil.js';
import {attachWorkspaceFilterState, readTypeAheadUnitState, restoreTypeAheadUnitState, resolveUnitByCode} from '../../utils/workspaceStateUtil.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {BaseComponent} from '../basecomponent.js';
import {DataTools} from './dataTools.js';


/* global customElements */
class FuelGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var fuelGrid = this;
		setTimeout(function(){
			fuelGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var fuelGrid = this;
		
		var lookupRequestId = 0;
		var loadReferenceLookup = function (refType, lookupValue, selectedUnitId) {
			var requestId = ++lookupRequestId;
			var paging = {
				max: 100
			};
			if (lookupValue) {
				paging.filterField = 'description';
				paging.filterValue = lookupValue;
			}

			return UnitService.getUnitLookupService().getUnits(refType, paging).then(function (units) {
				if (requestId !== lookupRequestId) {
					return;
				}

				units.data = units.data || [];
				units.data.push({
					code: 'UNREF',
					description: 'Unreferenced'
				});

				var unitField = ElementUtil.query(toolbarFilter, 'filterUnitId');
				var applyItems = function(items) {
					if (requestId !== lookupRequestId) {
						return;
					}
					unitField.items = items;
					if (selectedUnitId) {
						unitField.value = selectedUnitId;
					} else if (!lookupValue) {
						unitField.value = 'UNREF';
					}
				};

				if (selectedUnitId && selectedUnitId !== 'UNREF') {
					var found = units.data.some(function(unit) {
						return unit.code === selectedUnitId;
					});
					if (!found) {
						return UnitService.getUnitLookupService().getUnits(refType, {
							max: 1,
							filterField: 'code',
							filterValue: selectedUnitId
						}).then(function(matched) {
							if (matched && matched.data && matched.data.length) {
								units.data = matched.data.concat(units.data);
							}
							applyItems(units.data);
						});
					}
				}
				applyItems(units.data);
			});
		};
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [		
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterReferenceType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Equipment Type',
					'item-value-path': 'code',
					'item-label-path': 'description',				
					value: 'TRACTOR',
					postinit: function(combo) {		
						Service.getLookupService().getLookupValues('ReferenceType').then(function (data) {
							var equipment = [];
							data.forEach(function(item){
								if (item.equipmentReference) {
									equipment.push(item);
								}
							});
							combo.items = equipment;
							combo.required = true;
						});
					},
					placeHolder: 'Select',
					listeners: {						
						change: function() {							
							var unitType = ElementUtil.query(toolbarFilter, 'filterReferenceType');
							var unitCB = ElementUtil.query(toolbarFilter, 'filterUnitId');
							loadReferenceLookup(unitType.value, null);
						}
					}
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterUnitId',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Reference',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,					
					postinit: function(combo) {																	
					},
					placeHolder: 'Unreferenced',
					listeners: {
						input: {
							fn: function(e) {
								var unitType = ElementUtil.query(toolbarFilter, 'filterReferenceType');
								loadReferenceLookup(unitType.value, e.target.value);	
							},
							buffer: 500
						},
						change: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Start Date',												
					name: 'filterStartDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.startPreviousMonth());	
					}()
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'End Date',												
					name: 'filterEndDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.endPreviousMonth());	
					}()
				}				
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['GPS_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['GPS_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'showMap',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['FUEL_MANAGEMENT:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:globe', ' Show on Map')						
					],
					listeners: {
						click: function() {
							actionShowMap(grid.selectedItems);
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'tools',
					'class': 'spacer-toolbar-item',
					disabled: true,
					permissions: ['FUEL_MANAGEMENT:WRITE,FUEL_MANAGEMENT:TIME_SHIFT,GPS_MANAGEMENT:WRITE'],	
					children:[
						ElementUtil.makeIcon('vaadin:cog', ' Tools')						
					],
					properties: {
						menu: [						
							{
								tag: 'dl-action-menu-item',
								itemId: 'reReference',							
								permissions: ['FUEL_MANAGEMENT:WRITE'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:arrow-right"></vaadin-icon> Re-Reference',
								listeners: {
									click: function(event) {
										actionReReference(grid.selectedItems);
									}
								}
							},							
							{
								tag: 'dl-action-menu-item',
								itemId: 'timeshift',
								permissions: ['FUEL_MANAGEMENT:TIME_SHIFT'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:clock"></vaadin-icon> Time Shift',
								listeners: {
									click: function(event) {
										actionTimeShift(grid.selectedItems);
									}
								}
							},							
							{
								tag: 'dl-action-menu-item',
								itemId: 'addGPS',
								permissions: ['GPS_MANAGEMENT:WRITE'],															
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:filter"></vaadin-icon> Add to GPS',
								listeners: {
									click: function(event) {
										actionAddToGPS(grid.selectedItems);	
									}
								}
							}
						]
					}
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'bulk-tools',
							'class': 'spacer-toolbar-item',	
							permissions: ['FUEL_MANAGEMENT:WRITE,FUEL_MANAGEMENT:TIME_SHIFT,FUEL_MANAGEMENT:BULK_DELETE'],
							children:[
								ElementUtil.makeIcon('vaadin:cogs', ' Bulk')						
							],
							properties: {
								menu: [		
									{
										tag: 'dl-action-menu-item',
										itemId: 'bulk-match-unref',
										permissions: ['FUEL_MANAGEMENT:WRITE'],
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:check-square"></vaadin-icon> Match-Unreferenced',
										listeners: {
											click: function(event) {
												actionMatchUnref();
											}
										}
									},
									{
										tag: 'dl-action-menu-item',
										itemId: 'bulk-timeshift',
										permissions: ['FUEL_MANAGEMENT:TIME_SHIFT'],
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:clock"></vaadin-icon> Time Shift',
										listeners: {
											click: function(event) {
												actionTimeShiftBulk();
											}
										}
									},																		
									{
										tag: 'hr'
									},
									{
										tag: 'dl-action-menu-item',
										itemId: 'bulk-delete',
										style: 'color: red',
										permissions: ['FUEL_MANAGEMENT:BULK_DELETE'],
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:trash"></vaadin-icon> Delete',
										listeners: {
											click: function(event) {
												actionBulkDelete();
											}
										}
									}
								]
							}
						},
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',					
							permissions: ['FUEL_MANAGEMENT:WRITE'],						
							children:[
								ElementUtil.makeIcon('vaadin:upload', ' Import')						
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}							
						},
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							'class': 'spacer-toolbar-item',	
							theme: 'error primary',
							permissions: ['FUEL_MANAGEMENT:DELETE'],							
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')						
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems);
								}
							}							
						}
					]
				}											
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},	
				{						
					path: 'recordDts',
					header: 'Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.recordDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'location.name',
					header: 'Location Name',					
					width: '7em'
				},
				{						
					path: 'location.addressLine1',
					header: 'Address',
					width: '7em'
				},
				{						
					path: 'location.city',
					header: 'City',
					width: '7em'
				},
				{						
					path: 'location.stateProv',
					header: 'State',
					width: '7em'
				},
				{						
					path: 'location.country',
					header: 'Country',
					width: '7em'
				},
				{						
					path: 'purchaseQty',
					header: 'Quantity',
					width: '7em',
					'text-align': 'end'
				},
				{						
					path: 'fuelPriceAmt',
					header: 'Unit Price',
					width: '7em',
					'text-align': 'end',
					renderer: function(root, column, rowData) {						
						root.innerHTML = StringUtil.currencyFormat(rowData.item.fuelPriceAmt);
					}
				},
				{						
					path: 'invoiceNo',
					header: 'Invoice No',
					width: '7em'
				},
				{						
					path: 'unit.originalRefNo',
					header: 'Original Ref No',
					width: '7em'
				},
				{						
					path: 'fuelType',
					header: 'Fuel Type',
					width: '7em'
				},
				{						
					path: 'entryMethodDescription',
					header: 'Entry Method',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'originalFilename',
					header: 'Original Filename',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'comment',
					header: 'Comment',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateUser',
					header: 'Update User',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					hidden: true,
					width: '7em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);
					}
				},
				{						
					path: 'driver.originalRefNo',
					header: 'Driver Ref No',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'odometer',
					header: 'Odometer',
					hidden: true,
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.odometer && rowData.item.odometer.odometer != null) {
							root.innerHTML = rowData.item.odometer.odometer;
						} else {
							root.innerHTML = '';
						}
					}
				},
				{						
					path: 'taxable',
					header: 'Taxable',
					hidden: true,
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var gallonLabel = function(quantity) {
			return quantity === 1 ? 'GALLON' : 'GALLONS';
		};
		
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {
					if (grid.selectedItems.length === 1) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;						
						ElementUtil.query(toolbar, 'showMap').disabled = false;
						ElementUtil.query(toolbar, 'tools').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = false;
						ElementUtil.query(toolbar, 'showMap').disabled = false;
						ElementUtil.query(toolbar, 'tools').disabled = false;
					}
					
					var totalFuel = 0;
					grid.selectedItems.forEach(function(record) {
						//check quantity UOM and convert as needed
						if (record.quantityUom === 'LITER') {
							totalFuel += UOMUtil.convertLitersToGallons(record.purchaseQty);
						} else {
							totalFuel += record.purchaseQty;
						}
					});
					totalFuel = Math.round(totalFuel * 1000) / 1000;
					
					selectedFuelStatus.innerHTML = '<b>Selected Fuel:</b> ' + totalFuel + ' ' + gallonLabel(totalFuel) + ' | ';
				} else {						
					ElementUtil.query(toolbar, 'edit').disabled = true;	
					ElementUtil.query(toolbar, 'delete').disabled = true;
					ElementUtil.query(toolbar, 'showMap').disabled = true;
					ElementUtil.query(toolbar, 'tools').disabled = true;
					
					selectedFuelStatus.innerHTML = '';
				}					
			});
		};
		
		var selectedFuelStatus =  ElementUtil.create({
			tag: 'span'
		});
		
		var fuelStatus =  ElementUtil.create({
			tag: 'span',			
			trustedInnerHTML: true,
			innerHTML: '<b>Fuel:</b> 0 GALLONS'
		});				
		
		var exportToolbar = ElementUtil.create({
			tag: 'dl-export-toolbar',
			children: [
				{
					tag: 'span',
					slot: 'status',
					children: [
						selectedFuelStatus,						
						fuelStatus
					]
				}
			],
			listeners: {
				ready: function() {
					exportToolbar.updateGrid(grid);
				},
				'click-detail': function() {
					var referenceType = ElementUtil.query(toolbarFilter, 'filterReferenceType').value;
					var unitId = ElementUtil.query(toolbarFilter, 'filterUnitId').value;
					if (referenceType && unitId) {
						DataManagementService.getFuelService().exportFuel(referenceType, unitId, grid.currentFilter);
					} else {
						ElementUtil.query(toolbarFilter, 'filterUnitId').validate();
						ElementUtil.query(toolbarFilter, 'filterReferenceType').validate();
						DL.MessageUtil.showToastError('A unit must be selected');
					}
				}
			}
		});
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
						
						var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterStartDate').value);										
						var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterEndDate').value);		
						
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'recordDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',								
							start: startFilterDts,														
							end: endFilterDts,
							dateField: 'recordDts'
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];
							gridSelectionChange();
							
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();
							
							var totalFuel = Math.round(records.totalFuel.purchaseQty * 1000) / 1000;
							
							fuelStatus.innerHTML = '<b>Fuel:</b> ' + totalFuel + ' ' + gallonLabel(totalFuel);							
						};
						
						var referenceType = ElementUtil.query(toolbarFilter, 'filterReferenceType').value;
						var unitId = ElementUtil.query(toolbarFilter, 'filterUnitId').value;
						if (referenceType && unitId) {						
							DataManagementService.getFuelService().getFuel(referenceType, unitId, grid.currentFilter).then(function(records){
								successHandler(records);
							});						
						} else {
							loadMask.remove();
							if (fuelGrid.nextLoadOfGrid) {
								ElementUtil.query(toolbarFilter, 'filterReferenceType').validate();
								ElementUtil.query(toolbarFilter, 'filterUnitId').validate();								
								DL.MessageUtil.showToastError('Equipment type and unit must be selected');
							} else {
								fuelGrid.nextLoadOfGrid = true;
							}
						}
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footerContainer = ElementUtil.create({
			tag: 'div',
			slot: 'footer',
			children: [
				exportToolbar,
				{
					tag: 'div',
					style: 'border-top: 1px solid lightgrey;'
				},
				pagingToolbar
			]
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footerContainer
			]
		});		
		fuelGrid.append(flexLayout);			
		
		loadReferenceLookup('TRACTOR', null);
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};

		fuelGrid.toolbarFilter = toolbarFilter;
		fuelGrid.pagingToolbar = pagingToolbar;
		attachWorkspaceFilterState(fuelGrid, toolbarFilter,
			['filterReferenceType', 'filterUnitId', 'filterStartDate', 'filterEndDate'],
			actionRefresh,
			{
				save: function(state) {
					var unitState = readTypeAheadUnitState(ElementUtil.query(toolbarFilter, 'filterUnitId'));
					state.filterUnitId = unitState.value;
					state.filterUnitDescription = unitState.description;
				},
				restore: function(data) {
					if (data.filterStartDate !== undefined && data.filterStartDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterStartDate').value = data.filterStartDate;
					}
					if (data.filterEndDate !== undefined && data.filterEndDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterEndDate').value = data.filterEndDate;
					}
					var referenceType = data.filterReferenceType;
					if (referenceType !== undefined && referenceType !== null) {
						ElementUtil.query(toolbarFilter, 'filterReferenceType').value = referenceType;
					} else {
						referenceType = ElementUtil.query(toolbarFilter, 'filterReferenceType').value;
					}
					var refType = referenceType || 'TRACTOR';
					restoreTypeAheadUnitState({
						combo: ElementUtil.query(toolbarFilter, 'filterUnitId'),
						refType: refType,
						unitId: data.filterUnitId,
						description: data.filterUnitDescription,
						loadLookup: loadReferenceLookup,
						resolveByCode: function(type, unitId) {
							return resolveUnitByCode(function(referenceType, paging) {
								return UnitService.getUnitLookupService().getUnits(referenceType, paging);
							}, type, unitId);
						}
					}).then(function() {
						actionRefresh();
					});
				}
			});
		
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit Fuel' : 'Add Fuel',
				icon: 'vaadin:edit',				
				width: 800,
				height: .80,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						
						var loadReferenceNo = function (refType, lookupValue, cbToPopulate, callback) {
							var paging = {
								max: 100
							};
							if (lookupValue) {
								paging.filterField = 'description';
								paging.filterValue = lookupValue;
							}
							UnitService.getUnitLookupService().getUnits(refType, paging).then(function (units) {
								cbToPopulate.items = units.data;
								if (callback) {
									callback(cbToPopulate);
								}
							});

						};
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [		
										{										
											tag: 'vaadin-combo-box',
											itemid: 'referenceType',
											name: 'referenceType',
											label: 'Equipment Type',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											value: 'TRACTOR',
											postinit: function(combo) {		
												Service.getLookupService().getLookupValues('ReferenceType').then(function (data) {
													var equipment = [];
													data.forEach(function(item){
														if (item.equipmentReference) {
															equipment.push(item);
														}
													});
													combo.items = equipment;
													combo.required = true;
												});
											},
											placeHolder: 'Select',
											listeners: {						
												change: function() {							
													var unitType = ElementUtil.query(formPanel, 'referenceType');
													var unitCB = ElementUtil.query(formPanel, 'unitId');
													loadReferenceNo(unitType.value, null, unitCB);
												}
											}
										},										
										
										{
											tag: 'vaadin-combo-box',
											itemid: 'unitId',
											label: 'Reference',
											name: 'unitId',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,											
											postinit: function (combo) {												
											},
											listeners: {
												input: {
													fn: function (e) {
														var unitType = ElementUtil.query(formPanel, 'referenceType');
														var unitCB = ElementUtil.query(formPanel, 'unitId');
														loadReferenceNo(unitType.value, ElementUtil.resolveComboInputValue(e, unitCB), unitCB);															
													},
													buffer: 500
												}
											}
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'driverRefNo',
											label: 'Driver Id',
											name: 'driverRefNo',
											'item-value-path': 'description',
											'item-label-path': 'description',
											'allow-custom-value': true,
											postinit: function (combo) {
											},
											listeners: {
												input: {
													fn: function (e) {
														var driverRefNoCB = ElementUtil.query(formPanel, 'driverRefNo');
														loadReferenceNo('DRIVER', ElementUtil.resolveComboInputValue(e, driverRefNoCB), driverRefNoCB);
													},
													buffer: 500
												}
											}
										},
										{
											tag: 'vaadin-date-time-picker',
											label: 'Date(mm/dd/yyyy hh:mm:ss)',
											name: 'recordDts',
											step: 1,
											required: true
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'timezoneCB',
											label: 'TimeZone',
											name: 'timezone',
											'item-value-path': 'code',
											'item-label-path': 'description',
											value: TimeUtil.getCompanyTimeZoneNameOnly(),
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('TimeZone').then(function (data) {
													combo.items = data;
												});
											}											
										},										
										{
											tag: 'vaadin-combo-box',										
											label: 'Fuel Type',
											name: 'fuelType',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											value: 'DSL',
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('FuelType').then(function (data) {
													combo.items = data;
													combo.required = true;
												});
											}
										},										
										{
											tag: 'div',
											children: [
												{
													tag: 'dl-location-lookup',
													itemid: 'locationLookup',
													textstyle: 'width: calc(100% - 41px)',
													name: 'rawLocation',
													required: true									
												}
											]
										},
										{
											tag: 'vaadin-text-field',										
											name: 'invoiceNo',
											label: 'Invoice No',
											required: true,
											maxLength: 60	
										},
										{
											tag: 'div',
											children: [
												{
													tag: 'vaadin-number-field',												
													name: 'purchaseQty',
													label: 'Quantity',
													required: true,
													style: 'width: 48%',
													min: -999999,
													max: 999999
												},
												{
													tag: 'vaadin-combo-box',										
													label: 'Units',
													name: 'quantityUom',
													style: 'width: 50%; margin-left: 5px;',
													'item-value-path': 'code',
													'item-label-path': 'description',													
													value: 'GALLON',
													postinit: function (combo) {
														Service.getLookupService().getLookupValues('FuelQuantityUOM').then(function (data) {
															combo.items = data;
															combo.required = true;
														});
													}													
												}
											]
										},
										{
											tag: 'div',
											children: [
												{
													tag: 'vaadin-number-field',												
													name: 'fuelPriceAmt',
													label: 'Price Per Unit',
													style: 'width: 48%',
													required: true,
													min: -99999,
													max: 99999
												},
												{
													tag: 'vaadin-combo-box',										
													label: 'Currency',
													name: 'currencyCode',
													style: 'width: 50%; margin-left: 5px;',
													'item-value-path': 'code',
													'item-label-path': 'description',													
													value: 'USD',
													postinit: function (combo) {
														Service.getLookupService().getLookupValues('CurrencyCode').then(function (data) {
															combo.items = data;
															combo.required = true;
														});
													}													
												}
											]
										},																		
										{
											tag: 'vaadin-text-field',										
											name: 'locationName',
											label: 'Location Name',											
											maxLength: 255											
										},
										{
											tag: 'vaadin-number-field',
											itemid: 'odometerField',
											name: 'odometer',
											label: 'Odometer',
											min: 0,
											max: 999999999
										},
										{
											tag: 'vaadin-text-field',										
											name: 'comment',
											label: 'Comment',											
											maxLength: 255											
										},
										{
											tag: 'vaadin-checkbox',
											name: 'taxable',
											label: 'Taxable',
											checked: true
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																	
															var timezone = ElementUtil.query(formPanel, 'timezoneCB').value;
															formPanel.submitForm({
																timezone: timezone,
																preSubmit: function(data) {
																	var odometerField = ElementUtil.query(formPanel, 'odometerField');
																	if (odometerField) {
																		var rawOdometer = odometerField.value;
																		if (rawOdometer === '' || rawOdometer === undefined || rawOdometer === null) {
																			data.odometer = null;
																		} else {
																			data.odometer = rawOdometer;
																		}
																	} else if (data.odometer === '' || data.odometer === undefined) {
																		data.odometer = null;
																	}
																	return data;
																},
																actualCall: function(data) {			
																	if (record) {
																		data.recordId = record.recordId;
																	}																	
																	
																	return DataManagementService.getFuelService().saveFuel(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Fuel', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						var updateTractorCB = function() {
							
							var typeFilter = ElementUtil.query(toolbarFilter, 'filterReferenceType').selectedItem;
							var unitIdFilter = ElementUtil.query(toolbarFilter, 'filterUnitId').selectedItem;
							var initialValue = null;
							if (unitIdFilter && unitIdFilter.description !== 'Unreferenced') {								
								initialValue = unitIdFilter.description;
							}
							var refNoCB = ElementUtil.query(formPanel, 'unitId');	
							loadReferenceNo(typeFilter.code, initialValue, refNoCB, function(cb) {
								if (unitIdFilter && unitIdFilter.description !== 'Unreferenced') { 
									refNoCB.value = unitIdFilter.code;
								}
							});
						};
						
						if (record) {	
							var odometerValue = null;
							if (record.odometer && record.odometer.odometer != null && record.odometer.odometer !== '') {
								odometerValue = record.odometer.odometer;
							}
							var formRecord = {
								tractorId: record.tractorId,
								recordDts: record.recordDts,		
								rawLocation: record.location.latitude + ', ' + record.location.longitude,
								currencyCode: record.currencyCode,
								comment: record.comment,
								locationName: record.location.name,
								fuelPriceAmt: record.fuelPriceAmt,
								fuelType: record.fuelType,
								invoiceNo: record.invoiceNo,
								purchaseQty: record.purchaseQty,
								quantityUom: record.quantityUom,
								referenceType: record.unit ? record.unit.referenceType : record.referenceType,
								unitId: record.unit ? record.unit.referenceId : record.unitId,
								driverRefNo: record.driver ? record.driver.originalRefNo : null,
								odometer: odometerValue,
								taxable: record.taxable
							};
							
							//set location based on what we have.
							var hasAddress = !!record.location.addressLine1;
							var hasLatLong = record.location.latitude && record.location.longitude;
							if (hasAddress) {
								var addressLocationParts = [record.location.addressLine1];
								if (record.location.city) {
									addressLocationParts.push(record.location.city);
								}
								if (record.location.stateProv) {
									addressLocationParts.push(record.location.stateProv);
								}
								formRecord.rawLocation = addressLocationParts.join(', ');
							} else if (hasLatLong) {
								formRecord.rawLocation = record.location.latitude + ', ' + record.location.longitude;
							} else {
								formRecord.rawLocation = record.location.stateProv + '-' + record.location.country;
							}
							
							//wait for render;shift to end of event loop
							setTimeout(function() {
								formPanel.load(formRecord);
								updateTractorCB();
								var locationLookup = ElementUtil.query(formPanel, 'locationLookup');
								var locationTextField = locationLookup ? ElementUtil.query(locationLookup, 'text') : null;
								if (locationTextField) {
									if (hasAddress && hasLatLong) {
										locationTextField.helperText = record.location.latitude + ', ' + record.location.longitude;
									} else if (!hasAddress && hasLatLong) {
										var locationHelperParts = [];
										if (record.location.city) {
											locationHelperParts.push(record.location.city);
										}
										if (record.location.stateProv) {
											locationHelperParts.push(record.location.stateProv);
										}
										locationTextField.helperText = locationHelperParts.join(' ');
									} else {
										locationTextField.helperText = '';
									}
								}
								var odometerField = ElementUtil.query(formPanel, 'odometerField');
								if (odometerField) {
									odometerField.value = odometerValue != null ? odometerValue : '';
								}
								if (formRecord.driverRefNo) {
									var driverRefNoCB = ElementUtil.query(formPanel, 'driverRefNo');
									loadReferenceNo('DRIVER', formRecord.driverRefNo, driverRefNoCB, function(cb) {
										var hasMatch = false;
										if (cb.items) {
											for (var i = 0; i < cb.items.length; i++) {
												if (cb.items[i].description === formRecord.driverRefNo) {
													hasMatch = true;
													break;
												}
											}
										}
										if (!hasMatch) {
											cb.items = [{
												code: formRecord.driverRefNo,
												description: formRecord.driverRefNo
											}];
										}
										cb.value = formRecord.driverRefNo;
									});
								}
							});
						} else {
							updateTractorCB();							
						}
					}
				}
			});			
		};		
		
		var actionDelete = function(records) {
			
			var multipleIds = {
				ids: []
			};
			records.forEach(function(record){
				multipleIds.ids.push(
					record.recordId
				);
			});
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete selected records?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							DataManagementService.getFuelService().deleteFuel(multipleIds)
							.then(function(result){
								loadMask.remove();
								window.DL.MessageUtil.showDeleteRecordsResult(result);
								actionRefresh();
							});
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};	
		
		var actionUpload = function() {
			ImportUtil.showUpload({
				dataTypes: 'FUEL',
				uploadUrl: '/api/resource/fuel-purchases/import'
			});
		};		
		
		var actionShowMap = function(records) {
			var mapWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Map',
				icon: 'vaadin:globe',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {
						mapWin.show();
						
						var map = ElementUtil.create({
							tag: 'dl-map-panel',
							slot: 'primary',
							style: 'width: 100%; height: 100%'
						});
						
						var toolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [								
								{
									tag: 'dl-action-button',					
									'class': 'spacer-toolbar-item',
									style: 'width: 225px;',
									permissions: [],
									children:[
										ElementUtil.makeIcon('vaadin:cogs', ' View')
									],
									properties: {
										menu: [
											{
												tag: 'vaadin-item',						
												innerHTML: 'Show Satellite',
												listeners: {
													click: function(event) {
														map.showSatellite();
													}
												}
											},
											{
												tag: 'vaadin-item',						
												innerHTML: 'Show Terrain',
												listeners: {
													click: function(event) {
														map.showTerrain();
													}
												}
											},
											{
												tag: 'vaadin-item',						
												innerHTML: 'Show Transportation',
												listeners: {
													click: function(event) {
														map.showTransportation();
													}
												}
											}

										]
									}					
								}								
							]
						});						

						var mapFlexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [	
								toolbar,
								map				
							]
						});	
						
						mapWin.addToContentElement(mapFlexLayout);
						
						setTimeout(function(){
								
							//handle lat/long; address, city, state; city, state;  state (state pin)	
							var highRes = [];
							var notMappable = [];
							records.forEach(function(record){
								if (record.location.longitude && record.location.latitude) {
									highRes.push(record);
								} else {
									//note: alert
									notMappable.push(record);
								}
							});
							
							if (notMappable.length > 0) {
								window.DL.MessageUtil.showToast(notMappable.length + ' fuel location(s) are unable to be mapped.<br> Missing detailed location information.');
							}
								
							highRes.forEach(function(record){
								var longLats = [record.location.longitude, record.location.latitude];

								var date = TimeUtil.parseDate(record.recordDts);						
								var info = TimeUtil.formatDateStandard(date) + '<br>' 
										+ record.location.addressLine1 + ' ' + record.location.city + ', ' + record.location.stateProv + ' ' + record.location.country + '<br>'
										+ record.location.latitude + ', ' + record.location.longitude;

								map.addMarker(longLats, {
									popupHTML: info
								});
							});

							if (highRes.length === 1) {
								setTimeout(function() {
									map.zoomOnPoint([
										highRes[0].location.longitude,
										highRes[0].location.latitude
									]);
								}, 1000);
							}
							
						}, 200);						

					}
				}
			});
		};
		
		var actionReReference = function(records) {
			var primaryRecord = records[0];
			
			var referenceType = ElementUtil.query(toolbarFilter, 'filterReferenceType').value;
			var unitId = ElementUtil.query(toolbarFilter, 'filterUnitId').value;
			
			DataTools.referenceData({
				originalUnitId: unitId,
				referenceTypeOrigin: referenceType,		
				proceed: function(data, successCallback, failCallback) {
					
					var transferRequest = {
						referenceTypeOrigin: referenceType,
						referenceTypeDestination: data.referenceType,
						originalUnitId: unitId,
						destinationUnitId: data.destinationUnitId,
						dataToReReference: records
					};
					
					DataManagementService.getFuelService().reReferenceFuel(transferRequest).then(function(result){
						if (result.success) {							
							actionRefresh();
							if (successCallback) {
								successCallback(result);
							}							
						} else {														
							if (failCallback) {
								failCallback(result);
							}
						}
					});
					
				} 
			});
		};		
		
		var actionTimeShift = function(records) {
					
			var unitId = records[0].unit.referenceId;			
			records.sort(function(a, b) {
				return TimeUtil.compare(a.recordDts, b.recordDts);	
			});
						
			var startDts = records[0].recordDts;
			var endDts = records[records.length-1].recordDts;
						
			DataTools.timeShiftData({				
				proceed: function(data, successCallback, failCallback) {					
					data.dataType = 'GPS';		
					data.dataStartDts = startDts;
					data.dataEndDts = endDts;
					data.unitSelection = {
						type: 'CUSTOM',
						customList: [
							{
								unitId: unitId,
								referenceType: 'TRACTOR'
							}
						]
					};
					
					DataManagementService.getFuelService().timeshiftFuel(data).then(function(result){
						if (result.success) {							
							actionRefresh();
							if (successCallback) {
								successCallback(result);
							}							
						} else {														
							if (failCallback) {
								failCallback(result);
							}
						}
					});
				}
			});
			
		};
		
		var actionTimeShiftBulk = function() {
			DataTools.timeShiftData({
				bulk: true,
				proceed: function(data, successCallback, failCallback) {					
					data.dataType = 'GPS';					
										
					DataManagementService.getFuelService().timeshiftFuel(data).then(function(result){
						if (result.success) {							
							actionRefresh();
							if (successCallback) {
								successCallback(result);
							}							
						} else {														
							if (failCallback) {
								failCallback(result);
							}
						}
					});
				}
			});
		};
		
		var actionBulkDelete = function() {
			
			DataTools.deleteData({
				bulk: true,
				proceed: function(data, successCallback, failCallback) {	
					
					DataManagementService.getFuelService().deleteBulkFuel(data).then(function(result){
						if (result.success) {							
							actionRefresh();
							if (successCallback) {
								successCallback(result);
							}							
						} else {														
							if (failCallback) {
								failCallback(result);
							}
						}
					});
				}
			});
		};
		
		var actionAddToGPS = function(records) {
			var referenceType = ElementUtil.query(toolbarFilter, 'filterReferenceType').value;
			var unitId = ElementUtil.query(toolbarFilter, 'filterUnitId').value;
			
			var request = {
				originReferenceType: referenceType,
				originReferenceId: unitId,
				tractorIdTransferTo: unitId,  //For now transfer just the same...most likely the desired case
				dataIds: [],
				includeOdometer: false
			};
			records.forEach(function(record){
				request.dataIds.push(
					record.recordId
				);
			});

			var anyHaveOdometer = false;
			records.forEach(function(record) {
				if (record.odometer && record.odometer.odometer != null && record.odometer.odometer !== '') {
					anyHaveOdometer = true;
				}
			});

			var includeOdometerCheckbox = null;
			var dialog = ElementUtil.create({
				tag: 'vaadin-dialog',
				'no-close-on-esc': true,
				'no-close-on-outside-click': true
			});
			dialog.renderer = function(root) {
				var title = ElementUtil.create({
					tag: 'div',
					'class': 'dialog-title',
					innerHTML: 'Confirm GPS Creation'
				});

				var content = ElementUtil.create({
					tag: 'div',
					innerHTML: 'Are you sure you want to create GPS locations for the selected records?'
				});

				var children = [title, content];
				if (anyHaveOdometer) {
					includeOdometerCheckbox = ElementUtil.create({
						tag: 'vaadin-checkbox',
						label: 'Include fuel odometer as GPS actual odometer',
						style: 'margin-top: 12px; display: block;'
					});
					children.push(includeOdometerCheckbox);
				}

				children.push(document.createElement('br'));
				children.push(ElementUtil.create({
					tag: 'div',
					style: 'text-align: center;',
					defaults: {
						tag: 'vaadin-button'
					},
					children: [
						{
							style: 'margin-right: 5px;',
							innerHTML: 'Yes',
							listeners: {
								click: function() {
									if (includeOdometerCheckbox) {
										request.includeOdometer = includeOdometerCheckbox.checked === true;
									}
									dialog.remove();

									var loadMask = grid.showLoading('Creating GPS Records...');

									DataManagementService.getFuelService().transferToGPS(request)
									.then(function(results){
										loadMask.remove();
								
										if (results.success) {
											window.DL.MessageUtil.showToast('Success', 'Created/Updated: ' + request.dataIds.length + ' GPS records.', {									
												theme: 'success'
											});
											actionRefresh();
										}
									});
								}
							}
						},
						{
							innerHTML: 'No',
							listeners: {
								click: function() {
									dialog.remove();
								}
							}
						}
					]
				}));

				root.append.apply(root, children);
			};

			document.body.append(dialog);
			dialog.opened = true;
		};
		
		var actionMatchUnref = function() {
			
			var matchWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Match Unreferenced Records',
				icon: 'vaadin:check-square',				
				width: 700,
				height: 350,
				listeners: {
					ready: function() {						
						matchWin.show();	

						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [							
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-combo-box',
											itemid: 'referenceTypeCB',
											label: 'Reference Type',
											name: 'referenceType',
											colspan: 2,
											'item-value-path': 'code',
											'item-label-path': 'description',											
											value: 'TRACTOR',
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('ReferenceType').then(function (data) {
													var equipmentRefs = [];
													data.forEach(function(item){
														if (item.equipmentReference) {
															equipmentRefs.push(item);
														}
													});												
													combo.items = equipmentRefs;
													combo.required = true;
												});
											}
										},
										{
											tag: 'vaadin-date-time-picker',
											label: 'Start Date(mm/dd/yyyy hh:mm:ss)',
											name: 'startDts',											
											step: 1,
											value: TimeUtil.formatDateForTimeField(TimeUtil.startPreviousMonth()) + 'T00:00:00',
											required: true
										},
										{
											tag: 'vaadin-date-time-picker',
											label: 'End Date(mm/dd/yyyy hh:mm:ss)',
											name: 'endDts',											
											step: 1,
											value: TimeUtil.formatDateForTimeField(TimeUtil.endPreviousMonth()) + 'T23:59:59',
											required: true
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:check', ' Match')
													],
													listeners: {
														click: function() {															

															if (formPanel.isValid()) {
																var data = formPanel.getData();

																var loadMask = formPanel.showLoading('Submitting task to match...');	
																DataManagementService.getFuelService().matchUnreferenced(data).then(function(result){
																	loadMask.remove();
																	
																	if (result.success) {							
																		actionRefresh();
																		window.DL.MessageUtil.showToast('Success', 'Submitted Matching Task.', {
																			theme: 'success',
																			position: 'top-stretch'
																		});
																		matchWin.close();						
																	} else {	
																		//fail
																		var errors = [];
																		for (var key in result.errors) {
																			errors.push(key + " - " + result.errors[key]);
																		}
																		window.DL.MessageUtil.showToastError('Failed to Submit task.<br>' + errors);
																	}
																});
																
															}	
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {																													
															matchWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			

						matchWin.addToContentElement(formPanel);

					}
				}
			});								
			
		};
		
	}

}
customElements.define('dl-fuel-grid', FuelGrid);


